<p-toast position="top-right" styleClass="promo-add-update-toast"></p-toast>

<p-sidebar [(visible)]="showAddEditPromotionSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <img style="scale: 0.8" *ngIf="promo.ServiceTypeId" src="{{serviceTypeImageLink}}" />
        <div class="sidebar-header-title">{{sideBarHeaderTitle}}</div>
        <div class="sidebar-header-sub-title"></div>
        <div class="ml-3">
            <button style="height: 35px;" class="bluedark-btn"
                    pButton label="Export Data"
                    *ngIf="promoId"
                    (click)="getOrdersByPromoReport(promoId)"></button>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div class="promo-content" *ngIf="!activePromoType && !loading && !promoId">
        <div class="promo-content-center-block">
            <div class="flex flex-row flex-wrap">
                <div class="promo-item-discount" (click)="setPromoType(promoTypeEnum.Discount)">
                    <div class="promo-item-discount-block">
                        <img src="/XpressApp/assets/images/promo/percentage-discount-ride.svg" />
                        <div class="promo-item-discount__title">Discount</div>
                        <div class="promo-item-discount__info">Peso Discount</div>
                        <!--                            <div class="promo-item-discount__info">e.g. 20% Off</div>-->
                    </div>
                </div>

                <!--                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.FixedAmountDiscount, serviceTypesEnum.Ride)">-->
                <!--                    <div class="promo-item-discount-block">-->
                <!--                        <img src="/XpressApp/assets/images/promo/fix-amount-discount-ride.svg" />-->
                <!--                        <div class="promo-item-discount__title">Ride Fixed Amount Discount</div>-->
                <!--                        <div class="promo-item-discount__info">Offers customers a fixed amount discount off the original price of your items</div>-->
                <!--                        <div class="promo-item-discount__info">e.g. ₱100 Off</div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.PercentageDiscount, serviceTypesEnum.Ride)">-->
                <!--                    <div class="promo-item-discount-block">-->
                <!--                        <img src="/XpressApp/assets/images/promo/percentage-discount-ride.svg" />-->
                <!--                        <div class="promo-item-discount__title">Ride Percentage Discount</div>-->
                <!--                        <div class="promo-item-discount__info">Offers customers a percentage discount off the original price of your items.</div>-->
                <!--                        <div class="promo-item-discount__info">e.g. 20% Off</div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.FixedAmountDiscount, serviceTypesEnum.Delivery)">-->
                <!--                    <div class="promo-item-discount-block">-->
                <!--                        <img src="/XpressApp/assets/images/promo/fix-amount-discount-send.svg" />-->
                <!--                        <div class="promo-item-discount__title">Send Fixed Amount Discount</div>-->
                <!--                        <div class="promo-item-discount__info">Offers customers a fixed amount discount off the original price of your items</div>-->
                <!--                        <div class="promo-item-discount__info">e.g. ₱100 Off</div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="promo-item-discount" (click)="changePromoType(promoTypeEnum.PercentageDiscount, serviceTypesEnum.Delivery)">-->
                <!--                    <div class="promo-item-discount-block">-->
                <!--                        <img src="/XpressApp/assets/images/promo/percentage-discount-send.svg" />-->
                <!--                        <div class="promo-item-discount__title">Send Percentage Discount</div>-->
                <!--                        <div class="promo-item-discount__info">Offers customers a percentage discount off the original price of your items.</div>-->
                <!--                        <div class="promo-item-discount__info">e.g. 20% Off</div>-->
                <!--                    </div>-->
                <!--                </div>-->

            </div>

        </div>
    </div>

    <div *ngIf="activePromoType && !loading">
        <div class="bx-pager bx-default-pager">
            <div class="bx-pager-item active" (click)="changeActiveMenuTab(menuTab.PromoDetails)">
                <span class="bx-pager-link " data-slide-index="0">Promo Details</span>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Mechanics)" (click)="changeActiveMenuTab(menuTab.Mechanics)">
                <span class="bx-pager-link" data-slide-index="1">Mechanics</span>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item"
                 [class.active]="checkIsActiveMenu(menuTab.Validity)" (click)="changeActiveMenuTab(menuTab.Validity)">
                <span class="bx-pager-link" data-slide-index="2">Validity</span>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Products)" (click)="changeActiveMenuTab(menuTab.Products)">
                <span class="bx-pager-link" data-slide-index="3">Products</span>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Locations)" (click)="changeActiveMenuTab(menuTab.Locations)">
                <span class="bx-pager-link" data-slide-index="4">Locations</span>
                <div class="arrow">

                </div>
            </div>
            <div class="bx-pager-item" [class.active]="checkIsActiveMenu(menuTab.Preview)" (click)="changeActiveMenuTab(menuTab.Preview)">
                <span class="bx-pager-link" data-slide-index="5">Preview</span>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.PromoDetails">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(76vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="flex flex-row">
                    <div class="col-5 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Promo Name <span class="sidebar-field__label-info">(Published name)</span></div>
                            <input type="text" [(ngModel)]="promo.Name" placeholder="Max 50 Characters" pInputText />
                            <!--<div class="sidebar-field__error-message">Required</div>-->
                        </div>
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Promo Code</div>
                            <input type="text" [(ngModel)]="promo.Code" placeholder="Enter Code" pInputText />
                        </div>

                        <div class="sidebar-field-block">
                            <label class="sidebar-field__label">Promo Type</label>
                            <p-dropdown placeholder="Select"
                                        [options]="promoTypes"
                                        optionLabel="name"
                                        optionValue="id"
                                        [showClear]="true"
                                        [(ngModel)]="promo.PromoTypeId">
                            </p-dropdown>
                        </div>

                        <div class="sidebar-field-block">
                            <label class="sidebar-field__label">Promo Budget</label>
                            <p-dropdown placeholder="Select budget"
                                        [options]="promoBudgets"
                                        optionLabel="Label"
                                        optionValue="Id"
                                        [filter]="true"
                                        filterBy="Label"
                                        [(ngModel)]="promo.PromoBudgetId">
                            </p-dropdown>
                        </div>
                    </div>

                    <div class="col-7 p-0 pl-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Promo Creative</div>
                            <div class="partner-promo-img-block" (click)="handleImageClick('idImgInput')">
                                <div class="partner-promo-upload-block" *ngIf="!promo.CoverUrl">
                                    <img src="/XpressApp/assets/images/upload-img.svg" />
                                    <div class="partner-promo-upload-block__title">Upload image</div>
                                    <div class="partner-promo-upload-block__subtitle">Minimum 600x320 pixels</div>
                                </div>
                                <img class="partner-promo-img" src="{{promo.CoverUrl}}" *ngIf="promo.CoverUrl" />
                                <input id="idImgInput"
                                       type="file"
                                       accept="image/*"
                                       style="display: none"
                                       (change)="handleImageChange($event)" required />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sidebar-field-block">
                    <div class="sidebar-field__label">Promo Description <span class="sidebar-field__label-info">(Published)</span></div>
                    <textarea rows="7" cols="30" pInputTextarea [(ngModel)]="promo.Description" placeholder="Add Description"></textarea>
                    <span>Maximum 500 characters</span>
                </div>

                <div class="sidebar-field-block">
                    <div class="sidebar-field__label">Promo Terms & Conditions <span class="sidebar-field__label-info">(Published)</span></div>
                    <p-editor [(ngModel)]="promo.HtmlView" [style]="{'height':'320px'}">
                        <ng-template pTemplate="header">
                            <span class="ql-formats">
                                <button type="button" class="ql-bold" aria-label="Bold"></button>
                                <button type="button" class="ql-italic" aria-label="Italic"></button>
                                <button type="button" class="ql-underline" aria-label="Underline"></button>
                            </span>
                            <span class="ql-formats">
                                <button type="button" class="ql-list" value="ordered">
                                </button>
                                <button type="button" class="ql-list" value="bullet">
                                </button>
                            </span>
                        </ng-template>
                    </p-editor>
                    <span>Maximum 1000 characters</span>
                </div>

                <div style="margin-left: 10px; margin-top: 25px;">
                    <div class="field">
                        <label class="block">Is Displayed on page</label>
                        <p-inputSwitch [(ngModel)]="promo.IsDispayedOnPage"></p-inputSwitch>
                    </div>

                    <div class="field">
                        <label class="block">Is Active</label>
                        <p-inputSwitch [(ngModel)]="promo.IsActive"></p-inputSwitch>
                    </div>
                </div>

            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Mechanics)"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Mechanics">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(76vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="partner-promo-title">Peso Discount</div>
                <div class="flex flex-row">
                    <div class="col-3 p-0 pr-1">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Use Percent <span class="sidebar-field__label-info"></span></div>
                            <div class="promo-discount"><span class="promo-peso">%</span> <p-inputNumber inputId="usePercent" suffix=" %" [(ngModel)]="promo.UsePercent"></p-inputNumber></div>
                        </div>
                    </div>
                    <div style="width: 40px"></div>
                    <div class="col-3 p-0 pr-1">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Peso Discount <span class="sidebar-field__label-info"></span></div>
                            <div class="promo-discount">
                                <span class="promo-peso">₱</span> <p-inputNumber inputId="discountValue" [minFractionDigits]="2"
                                                                                 [(ngModel)]="promo.UseAmount" placeholder="50"></p-inputNumber>
                            </div>
                        </div>
                    </div>
                    <div style="width: 40px"></div>
                    <div class="col-3 p-0 pl-1">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Flat Amount <span class="sidebar-field__label-info"></span></div>
                            <div class="promo-discount"><span class="promo-peso">₱</span> <p-inputNumber inputId="useFlatAmount" [minFractionDigits]="2" [(ngModel)]="promo.UseFlatAmount"></p-inputNumber></div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="col-3 p-0 pl-1">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Minimum Spend <span class="sidebar-field__label-info"></span></div>
                            <div class="promo-discount">
                                <span class="promo-peso">₱</span> <p-inputNumber inputId="minSpend" [minFractionDigits]="2"
                                                                                 [(ngModel)]="promo.MinSpend" placeholder="50"></p-inputNumber>
                            </div>
                        </div>
                    </div>
                    <div style="width: 40px"></div>
                    <div class="col-3 p-0 pl-1">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Maximum Amount <span class="sidebar-field__label-info"></span></div>
                            <div class="promo-discount"><span class="promo-peso">₱</span> <p-inputNumber inputId="minSpend" [minFractionDigits]="2" [(ngModel)]="promo.MaxAmount"></p-inputNumber></div>
                        </div>
                    </div>
                    <div style="width: 40px"></div>
                    <div class="col-3 p-0 pl-1">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Capped Amount <span class="sidebar-field__label-info"></span></div>
                            <div class="promo-discount"><span class="promo-peso">₱</span> <p-inputNumber inputId="cappedAmount" [minFractionDigits]="2" [(ngModel)]="promo.CappedAmount"></p-inputNumber></div>
                        </div>
                    </div>
                </div>

                <div class="partner-promo-title">Redemption Rules</div>
                <div class="flex flex-row">
                    <div class="col-6 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Total redemption limit <span class="sidebar-field__label-info"></span></div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="noLimit"
                                               value="0"
                                               label="No Limit"
                                               (onClick)="limitClick(false)"
                                               [(ngModel)]="promo.selectedLimit"></p-radioButton>
                                <div class="partner-promo-redemption-info" style="width: 220px;">Promotions will run until the end of date and time</div>
                            </div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="limit"
                                               value="1"
                                               label="Limit Redemption"
                                               (onClick)="limitClick(true)"
                                               [(ngModel)]="promo.selectedLimit"></p-radioButton>
                            </div>
                            <div class="sidebar-field-block" *ngIf="showLimit">
                                <p-inputNumber inputId="maxUseCount" [(ngModel)]="promo.MaxUseCount"
                                               placeholder="Maximum"
                                               [ngStyle]="{'width': '200px', 'margin-left': '25px'}"></p-inputNumber>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 pl-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Customer redemption limit <span class="sidebar-field__label-info"></span></div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="registeredTaxGroup"
                                               value="0"
                                               label="No Limit"
                                               (onClick)="limitPerDayClick(false)"
                                               [(ngModel)]="promo.selectedLimitPerDay"></p-radioButton>
                                <div class="partner-promo-redemption-info" style="width: 220px;">Customer can redeem as often as They like</div>
                            </div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="registeredTaxGroup"
                                               value="1"
                                               label="Limit Redemption"
                                               (onClick)="limitPerDayClick(true)"
                                               [(ngModel)]="promo.selectedLimitPerDay"></p-radioButton>
                            </div>
                            <div class="sidebar-field-block" *ngIf="showLimitPerDay">
                                <p-inputNumber inputId="MaxUsePerDayCount" [(ngModel)]="promo.MaxUsePerDayCount"
                                               placeholder="Maximum"
                                               [ngStyle]="{'width': '200px', 'margin-left': '25px'}"></p-inputNumber>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="partner-promo-title">What customer can avail this promo ?</div>
                <div class="flex flex-row">
                    <div class="col-7 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field-block">
                                <p-radioButton name="promoAvailableType"
                                               [value]="1"
                                               label="All customers"
                                               [(ngModel)]="promo.PromoAvailableType"></p-radioButton>
                                <div class="partner-promo-redemption-info">Promotions will be shown to all users</div>
                            </div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="promoAvailableType"
                                               [value]="2"
                                               label="New customers ONLY"
                                               [(ngModel)]="promo.PromoAvailableType"></p-radioButton>
                                <div class="partner-promo-redemption-info">Promotions will be shown to new customers only</div>
                            </div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="promoAvailableType"
                                               [value]="3"
                                               label="Returning customers ONLY"
                                               [(ngModel)]="promo.PromoAvailableType"></p-radioButton>
                                <div class="partner-promo-redemption-info">Promotions will be shown to existing customers only</div>
                            </div>
                            <div class="sidebar-field-block">
                                <p-radioButton name="promoAvailableType"
                                               [value]="promoAvailableType.CustomUsers"
                                               label="Custom users"
                                               [(ngModel)]="promo.PromoAvailableType"></p-radioButton>
                                <div class="partner-promo-redemption-info">Promotions will be available only to the uploaded user ids</div>
                            </div>
                            <div class="custom-users-file" *ngIf="promo.PromoAvailableType === promoAvailableType.CustomUsers">
                                <div class="custom-users-file__drop"
                                     [class.custom-users-file__drop--active]="customUsersDragOver"
                                     [class.custom-users-file__drop--filled]="!!customUsersFileName"
                                     (click)="handleImageClick('customUsersFileInput')"
                                     (dragover)="onCustomUsersDragOver($event)"
                                     (dragleave)="customUsersDragOver = false"
                                     (drop)="onCustomUsersFileDrop($event)">
                                    <input id="customUsersFileInput"
                                           type="file"
                                           accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                           (change)="onCustomUsersFileSelected($event)" />
                                    <div class="custom-users-file__icon" aria-hidden="true">
                                        <i class="pi" [class.pi-file-excel]="!!customUsersFileName" [class.pi-upload]="!customUsersFileName"></i>
                                    </div>
                                    <div class="custom-users-file__copy">
                                        <div class="custom-users-file__title" [class.custom-users-file__title--file]="!!customUsersFileName">
                                            {{ customUsersFileName || 'Upload Excel file' }}
                                        </div>
                                        <div class="custom-users-file__hint" *ngIf="!customUsersFileName">Drop a file here or click to browse</div>
                                        <div class="custom-users-file__hint" *ngIf="customUsersFileName">Click to replace this file</div>
                                    </div>
                                    <button type="button"
                                            class="custom-users-file__clear"
                                            *ngIf="customUsersFileName"
                                            (click)="clearCustomUsersFile($event)"
                                            aria-label="Remove file">
                                        <i class="pi pi-times"></i>
                                    </button>
                                </div>
                                <div class="custom-users-file__meta">
                                    <span class="custom-users-file__badge" *ngIf="savedCustomUserCount > 0">{{ savedCustomUserCount }} user ids saved</span>
                                    <span class="custom-users-file__note" *ngIf="savedCustomUserCount > 0 && !customUsersFileName">A new file replaces the saved list.</span>
                                    <span class="custom-users-file__note" *ngIf="savedCustomUserCount === 0 || customUsersFileName">Use a UserId column with one id per row.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="partner-promo-title">How many times the promo can be used ?</div>
                <div class="col-3 p-0 pl-4">
                    <div class="sidebar-field-block">
                        <p-inputNumber inputId="countUserUse" [(ngModel)]="promo.CountUserUse"></p-inputNumber>
                    </div>
                </div>


            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Validity)"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Validity">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(76vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="partner-promo-title">Promo validity period</div>
                <div class="flex flex-row">
                    <div class="col-6 p-0 pr-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">Start date and time <span class="sidebar-field__label-info"></span></div>
                            <div class="flex flex-row">
                                <div class="sidebar-field-column">
                                    <p-calendar inputId="startDate" [(ngModel)]="promo.StartedAt" (ngModelChange)="onStartDateChange()"></p-calendar>
                                </div>
                                <div class="sidebar-field-column">
                                    <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.StartedAtTime"></p-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 pl-4">
                        <div class="sidebar-field-block">
                            <div class="sidebar-field__label">End date and time <span class="sidebar-field__label-info"></span></div>
                            <div class="flex flex-row">
                                <div class="sidebar-field-column">
                                    <p-calendar inputId="endDate" [(ngModel)]="promo.ValidUntil" (ngModelChange)="onEndDateChange()"></p-calendar>
                                </div>
                                <div class="sidebar-field-column">
                                    <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.ValidUntilTime"></p-calendar>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="sidebar-field-block">
                    <div class="sidebar-field__label">Validity N Days From Signup Date <span class="sidebar-field__label-info"></span></div>

                    <div class="col-6 p-0">
                        <p-inputNumber inputId="validityDayFromSignupDate" [(ngModel)]="promo.ValidityDayFromSignupDate"></p-inputNumber>
                    </div>
                </div>

                <div class="sidebar-field-block">
                    <div class="sidebar-field__label">Applicable days <span class="sidebar-field__label-info"></span></div>

                    <p-selectButton [options]="daysWeek" [(ngModel)]="promo.SelectedDayWeeks" class="select-week"
                                    [multiple]="true" optionLabel="name" optionValue="value"></p-selectButton>
                </div>

                <div class="partner-promo-title">Time of day</div>
                <!--                <div class="sidebar-field-block">-->
                <!--                    <div class="sidebar-field-block">-->
                <!--                        <p-radioButton name="timeOfDay"-->
                <!--                                       value="0"-->
                <!--                                       label="While the store is open"-->
                <!--                                       (onClick)="betweenTimeOfDayClick(false)"-->
                <!--                                       [(ngModel)]="promo.whileStoreIsOpen"></p-radioButton>-->
                <!--                        <div class="partner-promo-redemption-info">Customers can redeem as often as they like</div>-->
                <!--                    </div>-->
                <!--                    <div class="sidebar-field-block">-->
                <!--                        <p-radioButton name="timeOfDay"-->
                <!--                                       value="1"-->
                <!--                                       label="Between"-->
                <!--                                       (onClick)="betweenTimeOfDayClick(true)"-->
                <!--                                       [(ngModel)]="promo.whileStoreIsOpen"></p-radioButton>-->
                <!--                        <div class="flex flex-row col-6" *ngIf="showBetweenTimeOfday">-->
                <div class="flex flex-row col-6">
                    <div class="sidebar-field-column">
                        <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.BetweenStartTime"></p-calendar>
                    </div>
                    <div class="sidebar-field-column">
                        <p-calendar [timeOnly]="true" inputId="timeonly" [(ngModel)]="promo.BetweenEndTime"></p-calendar>
                    </div>
                </div>
                <!--                    </div>-->
                <!--                </div>-->
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Products)"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Products">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(76vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="flex flex-row">
                    <div class="col-5 p-0 pr-4">
                        <div class="partner-promo-title">Applies to</div>
                        <div class="sidebar-field-block">
                            <p-multiSelect [options]="serviceAndVehicleTypes"
                                           placeholder="Select"
                                           [style]="{width:'400px'}"
                                           [showToggleAll]="false"
                                           [filter]="false"
                                           [showHeader]="false"
                                           optionLabel="name"
                                           [(ngModel)]="promo.ServiceAndVehicleTypes">
                            </p-multiSelect>
                        </div>

                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Locations)"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Locations">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(76vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="merchant-form">
                    <div class="merchant-label partner-promo-title">Include from locations</div>
                    <div class="field">
                        <p-dropdown placeholder="Select"
                                    [options]="geoZones"
                                    optionLabel="Name"
                                    [style]="{'width':'350px'}"
                                    [showClear]="true"
                                    [(ngModel)]="promo.Location"
                                    (ngModelChange)="handlePromoLocationChange()">
                        </p-dropdown>
                    </div>

                    <div *ngIf="locations">
                        <div class="promo-locations-count">{{locations.length}} location added</div>

                        <div class="promo-locations-block">
                            <div class="flex flex-row mb-3" *ngFor="let location of locations; let i = index;">
                                <div class="promo-location-name">{{location.Name}}</div>
                                <div class="promo-location-action">
                                    <i class="pi pi-times promo-location-remove" (click)="deleteLocation(i)"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="field" style="margin-left: 2px; margin-top: 15px;">
                        <p-checkbox label="Restrict Pickup & Dropoff" [binary]="true" [(ngModel)]="promo.IncludePickupAndDropZone"></p-checkbox>
                    </div>
                </div>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="changeActiveMenuTab(menuTab.Preview)"></button>
            </div>
        </div>

        <div *ngIf="activeMenuTab === menuTab.Preview">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(76vh)'}"
                           [styleClass]="'app-scrollpanel'">
                <div class="preview-phone-template">

                    <img src="/XpressApp/assets/images/promo/preview-phone-template.jpg" />
                    <div class="preview-template">
                        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 310px)'}"
                                       [styleClass]="'app-scrollpanel'">
                            <img src="{{promo.CoverUrl}}" />
                            <div class="promo-preview-text-small-gray">{{getServiceTypeName()}} Offer</div>
                            <div class="promo-preview-text-offer">{{promo.Name}}</div>
                            <div class="promo-preview-text-medium-gray">Valid until</div>
                            <div class="promo-preview-text-valid-period">{{promo.StartedAtStr}} - {{promo.ValidUntilStr}}</div>
                            <div class="promo-preview-gray-line">___________________________</div>
                            <div class="promo-preview-text-medium-gray">Use promo code: <span class="promo-preview-code">{{promo.Code}}</span></div>
                            <div class="promo-preview-text-medium-black">Promo Terms and Conditions:</div>
                            <div class="promo-preview-text-small-black" [innerHTML]="promo.HtmlView"></div>
                        </p-scrollPanel>
                    </div>

                </div>

                <p class="cp-availability-description">
                    Once you submit your promotion, it will be reviewved by Xpress before it is live on the platform,
                    please allow 1-2 days. <br><br>
                    By clicking {{promoId > 0 ? 'SAVE' : 'CREATE'}} you have read, understood and agree to the <a class="terms-of-service" href="https://www.xpress.ph/terms">Terms of Service</a>.
                </p>
            </p-scrollPanel>

            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="{{promoId > 0 ? 'Save' : 'Create'}}" (click)="clickSavePromo()"></button>
            </div>
        </div>

    </div>

    <!--<div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>-->
    <!--<div *ngIf="!loading">
        <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 190px)'}"
                       [styleClass]="'app-scrollpanel'">
            <div class="flex flex-row">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">Payout Account Type</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.PayoutAccountTypeId" [options]="payoutAccountTypes"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId === payoutAccountTypeEnum.EWallet">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <div class="merchant-label">E-Wallet Details</div>
                        <p-dropdown placeholder="Select" [(ngModel)]="payment.WalletDetailId" [options]="walletDetails"
                                    optionLabel="name" optionValue="value" [showClear]="true"></p-dropdown>
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                </div>
            </div>

            <div class="flex flex-row" *ngIf="payment.PayoutAccountTypeId !== undefined && payment.PayoutAccountTypeId !== null">
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountName" placeholder="Account Name" pInputText />
                    </div>
                </div>
                <div class="merchant-column merchant-column-50">
                    <div class="merchant-form">
                        <input type="text" [(ngModel)]="payment.AccountNumber" placeholder="Account Number" pInputText />
                    </div>
                </div>
            </div>
        </p-scrollPanel>
        <hr class="hr-filter" />
        <div class="flex justify-content-end mrg-10-0px">
            <button class="btn-darkblue" pButton label="{{(merchantId > 0 ? 'Update' : 'Add')}}"></button>
        </div>
    </div>-->

</p-sidebar>
